export default function SiteFooter() {
  return (
    <footer
      className="no-print mt-20"
      data-testid="site-footer"
      style={{
        borderTop: "1px solid var(--rule)",
        background:
          "linear-gradient(180deg, rgba(243,232,207,0.3), rgba(255,250,230,0.7))",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 py-8 text-center">
        <div className="ornament mb-4" aria-hidden>
          <span>&#10086;</span>
        </div>
        <p
          style={{
            fontFamily: "'IM Fell English', serif",
            fontStyle: "italic",
            color: "var(--ink-soft)",
            margin: 0,
            fontSize: "1rem",
          }}
        >
          A revised, readable presentation of the Rev.&nbsp;Fr.&nbsp;George Leo
          Haydock&rsquo;s commentary &mdash; following the Douay&ndash;Rheims
          Bible.
        </p>
        <p
          style={{
            color: "var(--ink-muted)",
            fontSize: "0.88rem",
            marginTop: "0.6rem",
            letterSpacing: "0.05em",
          }}
        >
          Public domain text &middot; 1859 edition &middot; Last revised{" "}
          {new Date().toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
      </div>
    </footer>
  );
}
